import { formatGetHeaders } from '@configurations/api-configuration';
import { FileDownloader } from '@price-card/providers/file-downloader.provider';
import { ReleaseDocumentationGateway } from '@scenario/gateways/release-documentation.gateway';
import { environment } from '../../../../../environments/environment';

interface PresignedDownloadUrl {
  downloadUrl: string;
}

export class ApiReleaseDocumentationGateway implements ReleaseDocumentationGateway {
  private readonly apiUrl = `${environment.backend_url}/api/v1/release-documentation`;

  constructor(private readonly fileDownloader: FileDownloader) {}

  async downloadByFileName(fileName: string, originalFileName: string): Promise<void> {
    const url = `${this.apiUrl}?fileName=${encodeURIComponent(fileName)}`;
    const response: Response = await fetch(url, await formatGetHeaders());

    if (!response.ok) {
      throw new Error('Error downloading release documentation: ' + response.statusText);
    }

    const { downloadUrl } = (await response.json()) as PresignedDownloadUrl;
    const fileResponse = await fetch(downloadUrl, { method: 'GET' });
    if (!fileResponse.ok) {
      throw new Error('Error downloading release documentation: ' + fileResponse.statusText);
    }

    this.fileDownloader.handle(await fileResponse.blob(), originalFileName);
  }
}
